import { api } from "../../../api/api.js";
import "../../../model/middleware/index.js";
import { selectAllFilterValues } from "../../../model/selectors/selectAllFilterValues.js";
import "../../../model/selectors/selectAllFilterValuesParameters.js";
import "../../../model/selectors/selectAvailableFilterValues.js";
import { selectAvailableFilterValuesParameters } from "../../../model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../model/selectors/selectDependentFilterKeysByKey.js";
import "../../../model/selectors/selectFilterImmutableQueries.js";
import "../../../model/selectors/selectFilterImmutableValues.js";
import "../../../model/selectors/selectFilterItemByKey.js";
import "../../../model/selectors/selectFilterItems.js";
import "../../../model/selectors/selectFilterValuesFields.js";
import "../../../model/selectors/selectGroupedFilterItemByKey.js";
import "../../../model/selectors/selectIsFilterValuesMissing.js";
import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../../../shared/config/env.js";
import "../../../../../shared/config/events.js";
import "../../../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../../../shared/lib/store/createAppApi.js";
import "../../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../../shared/lib/store/createAppSelector.js";
import "../../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../../shared/lib/store/hooks/useAppStore.js";
const useAvailableFilterValues = () => {
  const allFilterValuesQueryResultFromStore = useAppSelector(selectAllFilterValues);
  const availableFilterValuesParameters = useAppSelector(selectAvailableFilterValuesParameters);
  const availableFilterValuesQueryResult = api.useGetAvailableFilterValuesQuery(
    availableFilterValuesParameters,
    {
      skip: !allFilterValuesQueryResultFromStore.data
    }
  );
  return availableFilterValuesQueryResult;
};
export {
  useAvailableFilterValues
};
